import { Job } from "../../../generated/nest-graphql";
import { parseStoredMiles } from "../formatMiles.utils";
import { formatServiceDate, hasRecordedInspection, serviceDateOf } from "./vehicleHistoryData.utils";

export const PRE_JOB_CHECKLIST_SOURCE = "Pre-job checklist";

// The checklist writes the record's mileage; with no inspection of that reading it may be Ops', so no source is named.
export const mileageInspectionText = (jobs: Job[], storedOdometer?: string | null): string | null => {
  const miles = parseStoredMiles(storedOdometer);
  if (miles === null) return null;
  let match: { date: Date | null } | null = null;
  for (const job of jobs) {
    const checklist = job.preJobCheckListV2;
    if (!checklist || !hasRecordedInspection(checklist) || parseStoredMiles(checklist.odometer) !== miles) continue;
    const date = serviceDateOf(job);
    if (!match || (date?.getTime() ?? -Infinity) > (match.date?.getTime() ?? -Infinity)) match = { date };
  }
  if (!match) return null;
  // No-break spaces keep the date whole when a narrow screen wraps the line.
  const date = match.date && formatServiceDate(match.date).replace(/ /g, "\u00A0");
  return date ? `${PRE_JOB_CHECKLIST_SOURCE}, ${date}` : PRE_JOB_CHECKLIST_SOURCE;
};
